<div class="app-container">
  <page-header [icon]="'far-tags'" [title]="'tags'">
    <ng-container class="header-button">
      <btn
        [icon]="'far-plus'"
        [label]="'tag.create'"
        [title]="'tag.create' | translate"
        [classes]="['btn-first', 'float-right']"
        [routerLink]="['/tag']"
        [dataCyAttribute]="'go-tag'"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [totalItems]="totalItems()"
      [entity]="'tags'"
      (onSubmit)="queryTags.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
    >
      <div class="row">
        <div class="col-12 col-sm-6">
          <form-row-input
            [label]="'tag.name'"
            [model]="filters().name"
            (modelChange)="onNameFilterChange($event)"
            (keydown.enter)="queryTags.refetch()"
            [dataCyAttribute]="'tag-name-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-6">
          <form-row-select
            [label]="'tag.type'"
            [translationPrefix]="'tags.type.'"
            [model]="filters().type"
            (modelChange)="onTypeFilterChange($event)"
            [options]="tagTypes()"
            [dataCyAttribute]="'tag-type-filter'"
          ></form-row-select>
        </div>
      </div>
    </app-filter-form>

    <app-base-listing
      [query]="queryTags"
      [listName]="'tags'"
      [needsTranslationPrefix]="true"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
